module.exports = __webpack_public_path__ + "img/download_icon.01445494.svg";